import { useContext, useEffect, useState } from "react";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import organisms from "../../../../components/organisms";
import { useCallApi, useSampleFile, useUploadFile } from "./hook";
import {
    ErrorDataTable,
    HandleBulkInventoryApiReturn,
    PreparedDataReturn,
    TApiError,
    TExcelData,
    TStore,
} from "./interface";
import { useToasts } from "react-toast-notifications";
import { HeaderHeading } from "../../../../Context";
import molecules from "../../../../components/molecules";

const { BulkInventoryAdd } = organisms;
const { CreateModal } = molecules

const Index = () => {
    const { setHeader, setSidebar }: any = useContext(HeaderHeading);

    const { handleFileUpload, preparedData, prepareDataForTable } =
        useUploadFile();
    const { handleDownloadSampleFormate } = useSampleFile();
    const { handleBulkInventoryApi, verifyBulkInventory, getDuplicateBarcodesFormatted, getEmptyFieldsError } = useCallApi();

    const { addToast } = useToasts();

    //state to store loading state
    const [isLoading, setIsLoading] = useState<boolean>(false);

    //inventory Table data
    const [inventoryData, setInventoryData] = useState<
        HandleBulkInventoryApiReturn[]
    >([]);
    const [showErrorModal, setShowErrorModal] = useState<boolean>(false)

    //formatted Data
    const [formattedData, setFormattedData] = useState<PreparedDataReturn[]>();
    const [errorData, setErrorData] = useState<ErrorDataTable[]>();

    //handle the api error
    const [apiError, setApiError] = useState<TApiError[]>([])

    const columns = ["Storecode", "Product ID", "Barcode", "Unitcost", "Remark"];

    const handleSubmit = async () => {
        setIsLoading(true);
        const storeApiResponse: TApiError[] = []
        if (formattedData) {
            for (let i = 0; i < formattedData?.length; i++) {
                const response = await handleBulkInventoryApi(formattedData[i]);
                if (response?.status === 400) {
                    const findStoreData: TStore | undefined = inventoryData?.find((item) => item?.store?.store_code === formattedData[i].store_code)?.store
                    storeApiResponse?.push({
                        store: findStoreData,
                        api_response: response?.message || ''
                    })
                }
            }
            addToast("File Upload successfully", {
                appearance: "success",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
            setApiError(storeApiResponse)
            setIsLoading(false);
            setInventoryData([]);
        }
    };

    //function to valid of json data
    const verifyData = async (data: PreparedDataReturn[]) => {
        let modifiedData: HandleBulkInventoryApiReturn[] = [];
        const modifiedErrorData: ErrorDataTable[] = [];
        for (let i = 0; i < data?.length; i++) {
            const apiData = await verifyBulkInventory(data[i]);
            if (apiData?.status === 400) {
                if (apiData?.store_code || apiData?.product_id?.length > 0 || apiData?.barcode || apiData?.barcodes && apiData?.barcodes?.length > 0) {
                    if (apiData?.product_id?.length > 0) {
                        for (let i = 0; i < apiData?.product_id?.length; i++) {
                            modifiedErrorData.push({
                                Storecode: apiData?.store_code || '',
                                "Product ID": apiData?.product_id[i].product_id || '',
                                Barcode: apiData?.barcode || '',
                                Unitcost: apiData?.unit_cost || '',
                                Remark: apiData?.remark || '',
                                error_field: apiData?.error_field || ''
                            })
                        }
                    } else if (apiData?.barcodes?.length > 0) {
                        const requiredData = data?.find((item) => item?.store_code === apiData?.store_code)?.product_details;

                        for (let i = 0; i < apiData?.barcodes?.length; i++) {
                            const requiredProductId = requiredData?.find((item) => item?.barcodes?.includes(apiData?.barcodes[i]))
                            console.log('requiredProductId', requiredProductId)
                            modifiedErrorData.push({
                                Storecode: apiData?.store_code || '',
                                "Product ID": requiredProductId?.product_id || '',
                                Barcode: `${apiData?.barcodes[i]} (Duplicate)` || '',
                                Unitcost: requiredProductId?.cost_amount || 0,
                                Remark: apiData?.remark || '',
                                error_field: apiData?.error_field || ''
                            })
                        }
                    } else {
                        modifiedErrorData.push({
                            Storecode: apiData?.store_code || '',
                            "Product ID": apiData?.product_id || '',
                            Barcode: apiData?.barcode || '',
                            Unitcost: apiData?.unit_cost || '',
                            Remark: apiData?.remark || '',
                            error_field: apiData?.error_field || ''
                        })
                    }
                }
                setShowErrorModal(!showErrorModal);
            } else {
                let data2: HandleBulkInventoryApiReturn[] = prepareDataForTable(apiData, data[i]);
                modifiedData.push(...data2);

                const duplicateBarcode = getDuplicateBarcodesFormatted(data2);
                if (duplicateBarcode?.length > 0) {
                    modifiedErrorData.push(...duplicateBarcode);
                    setShowErrorModal(!showErrorModal);
                } else {
                    setInventoryData(modifiedData);
                }
            }
        }
        if (modifiedErrorData?.length > 0) {
            // setInventoryData([])
        }
        setErrorData(modifiedErrorData)
    };
    //end

    //callback function to task after excel data convert into json data
    const handleFileData = (data: TExcelData[]) => {
        setInventoryData([]);
        setApiError([]);
        const emptyDataFiled = getEmptyFieldsError(data);
        if (emptyDataFiled?.length > 0) {
            setShowErrorModal(!showErrorModal)
            setErrorData(emptyDataFiled)
        } else {
            let formatData = preparedData(data);
            verifyData(formatData);
            setFormattedData(formatData);
        }
    };

    useEffect(() => {
        setHeader("Bulk Inventory Upload");
        setSidebar(false);
    }, []);

    return (
        <Wrapper>
            <BulkInventoryAdd
                handleFileUpload={(value: any) =>
                    handleFileUpload(value, handleFileData)
                }
                handleDownloadSampleFormate={() =>
                    handleDownloadSampleFormate({
                        columns: columns,
                        fileName: "bulk_inventory_sample_excel",
                    })
                }
                inventoryData={inventoryData}
                // excelData={excelData}
                handleSubmit={() => handleSubmit()}
                isLoading={isLoading}
                errorData={errorData}
                apiError={apiError}
            />
            {/* Invalid Data popup */}
            <CreateModal
                show={showErrorModal}
                handleSubmit={() => setShowErrorModal(!showErrorModal)}
                submitBtnText={`Close`}
                onHide={() => setShowErrorModal(!showErrorModal)}
                show_margin={true}
            >
                <div className="modal-body text-center">
                    <span style={{ color: "red", fontSize: "30px" }}>⚠️</span>
                    {/* Large red invalid icon at the top */}
                    <div>
                        <i className="bi bi-exclamation-circle-fill text-danger" style={{ fontSize: "4rem" }}></i>
                    </div>

                    {/* Invalid message */}
                    <h4 className="text-danger">Invalid Data</h4>
                    <p className="text-muted">The data you entered in Excel is incorrect.</p>
                </div>

            </CreateModal>
            {/* end */}
        </Wrapper>
    );
};

export default Index;
